import { Box, Stack } from '@mui/material';
import { H5, H6, Paragraph, Small } from '@web/components/Typography';
import BazaarRating from '@web/components/BazaarRating';

const ProductReviewMobile = ({ reviews }) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(2, calc(50%-2rem))`,
          gridAutoColumns: 'minmax(300px, 1fr)',
          gridColumnGap: '1rem',
          gridAutoFlow: 'column',
          overflowX: 'auto',
        }}
      >
        {reviews.map((item, ind) => (
          <Box
            key={ind}
            sx={{
              borderRadius: '2rem',
              border: '1px solid #ccc',
              padding: '1rem',
            }}
          >
            <H5 mb={0.5}>{item.title}</H5>
            <Stack direction="row" justifyContent="space-between">
              <BazaarRating
                value={Number(item.rating)}
                fontSize="1rem"
                color="warn"
                readOnly
              />
              <Small>{item.review_date}</Small>
            </Stack>

            <Paragraph color="grey.700" truncate={4}>
              {item.details}
            </Paragraph>
            <Box mt={1}>
              <Small><H6>{item.reviewer}</H6> originally posted on {item.store}</Small>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
export default ProductReviewMobile;
